<evc-nav-button type="cta" size="xxl" variant="round" (click)="addLiveAsset()" *callToAction [disabled]="createLiveAssetDisabled()">
    <span class="top-cta-label">
        {{'liveAssets.createLiveAsset' | translate }}
    </span>
    <evc-svg-icon size="md" [icon]="'plus'"></evc-svg-icon>
</evc-nav-button>
<live-assets></live-assets>

